<template>
  <div>
    <div
      class="quick-summary"
      v-for="(item, index) in summaryData"
      :key="index"
    >
      <div class="quick-summary__row">
        <div class="quick-summary__row--item">
          <span class="subtitle">Last Updated:</span>
          <span class="value">{{ formatDateTime(item.LastUpdated) }}</span>
        </div>
        <div class="quick-summary__row--item">
          <span class="subtitle">Stake: </span
          ><span class="value">{{ formatCurrency(item.Stake) }}</span>
        </div>
      </div>
      <div class="quick-summary__row">
        <div class="quick-summary__row--item">
          <span class="subtitle">GGR:</span>
          <span class="value">{{ formatCurrency(item.GGR) }}</span>
        </div>
        <div class="quick-summary__row--item">
          <span class="subtitle">Margin: </span
          ><span class="value">{{ formatPercentage(item.Margin) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDateTime } from "@/utils/formatDate";
import { formatPercentage } from "@/utils/formatPercentage";
import { formatCurrency } from "@/utils/formatCurrency";
export default {
  name: "TodaySummary",
  props: {
    dataset: String,
    filter: Object,
  },
  data() {
    return {
      summaryData: null,
      interval: null,
    };
  },

  methods: {
    formatDateTime,
    formatPercentage,
    formatCurrency,
    async fetchData(siteId, networkId, operatorId) {
      // Dataset name is the store procedure name used to return the results.
      const payload = {
          filterOptions: {
            siteIds: siteId ? [siteId] : [],
            networkId,
            operatorId
          },
          report: "live-dashboard",
          dataset: this.$props.dataset.replace(/ /g, "")
        };

      await this.$store.dispatch("fetchData", payload)
        .then((response) => {
          this.summaryData = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  watch: {
    filter: function(filterOption) {
      this.fetchData(
        filterOption.siteId,
        filterOption.networkId,
        filterOption.operatorId
      );
      this.visible = true;

      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.fetchData(
          filterOption.siteId,
          filterOption.networkId,
          filterOption.operatorId
        );
      }, 180000);
    },
  },
  mounted() {
    this.fetchData(
      this.$store.state.siteFilter.id,
      this.$store.state.networkFilter.id,
      this.$store.state.selectedOperator.id
    );
    this.interval = setInterval(() => {
      this.fetchData(
        this.$store.state.siteFilter.id,
        this.$store.state.networkFilter.id,
        this.$store.state.selectedOperator.id
      );
    }, 180000);
  },
  // Prevent Memory Leak
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style lang="scss" scoped>
.quick-summary {
  width: auto;
  margin: 20px;
  &__row {
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-top: 0.5px solid #ececec;
    &--item {
      width: 50%;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      font-family: Barlow;
      color: #747474;
      font-size: 12px;
      line-height: 12px;
      .subtitle {
        font-weight: 700;
      }
      .value {
        font-weight: normal;
      }
    }
    &:nth-child(even) {
      background: #f5f9fd;
    }
  }
}
// Dark Mode
.body {
  &--dark {
    .quick-summary {
      &__row {
        border-top: 0.5px solid #353535;
        &--item {
          color: #fff;
        }
        &:nth-child(even) {
          background: #04080e;
        }
      }
    }
  }
}
</style>
